import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeHeaderTab: "",
};

const headerTabsSlice = createSlice({
  name: "activeHeaderTab",
  initialState,
  reducers: {
    setActiveHeaderTab: (state, action) => {
      state.activeHeaderTab = action.payload;
    },
  },
});

export const { setActiveHeaderTab } = headerTabsSlice.actions;

export default headerTabsSlice.reducer;
